<!--
 * @Author: your name
 * @Date: 2021-07-22 14:27:18
 * @LastEditTime: 2022-08-01 16:25:22
 * @LastEditors: yingna.gao
 * @Description: In User Settings Edit
 * @FilePath: /common-web/src/components/private/table/index.vue
-->
<template>
  <div class="custom__table">
    <!-- 批量删除 -->
    <div v-show="batchDelete" class="custom__table__delete--batch">
      <batch-delete
        v-if="multipleSelection.length"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :show-total="false"
        :show-batch-delete="true"
        :current-select-num="multipleSelection.length"
        @resetData="resetData"
        @currentPageall="currentPageall"
        @deleteData="deleteData"
      />
    </div>
    <!-- /批量删除 -->

    <!-- 表格 -->
    <div class="h100">
      <div class="custom_table_header" :style="{ height: height }">
        <el-table
          ref="multipleTable"
          v-skeleton="skeletonParams"
          class="self-table"
          :data="tableData"
          stripe
          border
          height="100%"
          @selection-change="handleSelectionChange"
          @header-dragend="handleHeaderDragend"
          @row-click="rowClick"
        >
          <el-table-column
            v-if="checkbox || batchDelete"
            fixed
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            v-if="order"
            :fixed="orderFixed"
            type="index"
            :label="$t('common.order')"
            width="80"
            :index="table_index"
          ></el-table-column>
          <slot></slot>
          <template slot="empty" class="empty">
            <empty v-show="(!tableData || !tableData.length) && !skeletonParams.loading" />
          </template>
        </el-table>
      </div>

      <!-- 表格分页 -->
      <pagination
        v-show="tableData && tableData.length && showPagination"
        :page-info="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <!-- /表格分页 -->
    </div>
    <!-- /表格 -->

    <!-- 表格空状态 -->
    <!-- <Empty v-show="(!tableData || !tableData.length) && !skeletonParams.loading" /> -->
    <!-- /表格空状态 -->
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination";
import BatchDelete from "@/components/private/batch-delete";
import Empty from "@/components/private/empty";

export default {
  name: "CustomTable",
  components: {
    Pagination,
    BatchDelete,
    Empty
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    batchDelete: {
      type: Boolean,
      default: false
    },
    checkbox: {
      type: Boolean,
      default: false
    },
    order: {
      type: Boolean,
      default: true
    },
    orderFixed: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: "88%"
    },
    pagination: {
      type: Object,
      default: () => ({
        pageNum: 1,
        pageSize: 10,
        total: 0
      })
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Array,
      default: () => {
        [];
      }
    },
    //  手动控制选中项用
    selectData: {
      type: Array,
      default: () => {
        [];
      }
    }
  },
  data() {
    return {
      multipleSelection: []
    };
  },
  computed: {
    skeletonParams() {
      return {
        loading: this.loading
      };
    }
  },
  watch: {
    // 监测骨架屏结束后，动态doLayout
    skeletonParams: {
      deep: true,
      handler() {
        this.$refs["multipleTable"].doLayout();
      }
    },
    selectData(val) {
      if (val) {
        this.$refs.multipleTable.clearSelection();
        val.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    }
  },
  methods: {
    // 序号
    table_index(index) {
      return (this.pagination.pageNum - 1) * this.pagination.pageSize + index + 1;
    },
    // 拖拽
    handleHeaderDragend(newWidth, oldWidth, column, event) {
      this.$emit("handleHeaderDragend", newWidth, oldWidth, column, event);
    },
    // 复选框
    handleSelectionChange(val) {
      if (this.checkbox || this.batchDelete) {
        this.multipleSelection = val;
        this.$emit("handleSelectionChange", val);
      }
    },
    // 行点击
    rowClick(val) {
      this.$emit("rowClick", val);
    },
    // 条数改变
    handleSizeChange(data) {
      this.$emit("handleSizeChange", data);
    },
    // 页数改变
    handleCurrentChange(data) {
      this.$emit("handleCurrentChange", data);
    },
    // 批量删除
    deleteData() {
      if (this.batchDelete) {
        this.$emit("batchDeleteData", this.multipleSelection);
      }
    },
    // 全选当前页
    currentPageall() {
      if (this.multipleSelection.length === this.tableData.length) { return; }
      this.$refs.multipleTable.toggleAllSelection();
    },
    // 清空
    resetData() {
      this.multipleSelection = [];
      this.$refs.multipleTable.clearSelection();
      this.$emit("checkedTable", []);
    },
    // 获取选中项
    getChecked() {
      return this.multipleSelection;
    }
  }
};
</script>

<style lang="scss" scoped>
.custom__table {
  height: calc(100% - 60px);
}
.custom_table_header {
  font-size: 14px;
  color: #21252e;
  font-family: PingFangSC, PingFangSC-Medium SourceSans Regular, sans-serif, "Microsoft YaHei",
    微软雅黑;
  font-weight: 400;
  ::v-deep .el-table{
          th,th:hover {
              border-right: 1px solid #d4d9e2;
          }
      }
}
</style>
